import { createSlice } from '@reduxjs/toolkit';

export const cognitiveStatusSlice = createSlice({
  name: 'cognitiveStatus',
  initialState: {
    selectedCognitiveStatuses: { display: '', value: '', type: 'cognitive' },
    cognitiveInputText: '',
  },
  reducers: {
    setSelectedCognitiveStatuses: (state, action) => {
      state.selectedCognitiveStatuses = action.payload;
    },
    setCognitiveInputText: (state, action) => {
      state.cognitiveInputText = action.payload;
    },
  },
});

// slice for multiple value add in dropdown

// export const cognitiveStatusSlice = createSlice({
//   name: 'cognitveStatus',
//   initialState: {
//     selectedCognitiveStatuses: [],
//     cognitiveInputText: '',
//   },
//   reducers: {
//     setSelectedCognitiveStatuses: (state, action) => {
//       const modifiedItems = action.payload.map(item => ({
//         ...item,
//         type: 'cognitive',
//       }));
//       state.selectedCognitiveStatuses = modifiedItems;
//     },
//     setCognitiveInputText: (state, action) => {
//       state.cognitiveInputText = action.payload;
//     },
//   },
// });

export const { setSelectedCognitiveStatuses, setCognitiveInputText } =
  cognitiveStatusSlice.actions;

export default cognitiveStatusSlice.reducer;
